import React, { useCallback } from 'react';
import { useField } from 'formik';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';
import { DisplayTransactionCategory, eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';

const transactionTypeOptions = Object.values(eTransactionCategory).map((category) => ({
  label: DisplayTransactionCategory[category],
  value: category,
  id: category,
}));

export const TransactionTypeFilter: React.FC = () => {
  const [field, meta, helpers] = useField<string[]>({ name: 'transactionCategories' });
  const onChange = useCallback(
    (nextValue: any) => {
      helpers.setValue(nextValue);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Transaction Type</Label>}
      control={
        <Combobox
          value={field.value}
          options={transactionTypeOptions}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          multiple
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
